<template>
  <div>
    <label for="comment" class="block text-sm font-medium leading-6 text-gray-900">
      {{ t("refusal_reason_label") }}
    </label>
    <div class="mt-2">
      <textarea
        rows="4"
        name="comment"
        id="comment"
        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
        :value="reason"
        @input="$emit('update:reason', $event.target.value)"
      />
    </div>

    <div v-if="showRefusalType" class="mt-4 flex space-x-4">
      <div class="flex items-center">
        <input
          id="ask-quotation"
          type="radio"
          name="refusal-type"
          value="ask_quotation"
          :checked="refusalType === 'ask_quotation'"
          class="h-4 w-4 text-primary focus:ring-primary border-gray-300"
          @change="$emit('update:refusalType', 'ask_quotation')"
        />
        <label for="ask-quotation" class="ml-2 block text-sm text-gray-700">{{ t("ask_quotation_label") }}</label>
      </div>
      <div class="flex items-center">
        <input
          id="reconfigure-handling"
          type="radio"
          name="refusal-type"
          value="reconfigure_handling"
          :checked="refusalType === 'reconfigure_handling'"
          class="h-4 w-4 text-primary focus:ring-primary border-gray-300"
          @change="$emit('update:refusalType', 'reconfigure_handling')"
        />
        <label for="reconfigure-handling" class="ml-2 block text-sm text-gray-700">
          {{ t("reconfigure_handling_label") }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "ApprovalRefusalForm",

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    reason: {
      type: String,
      default: "",
    },
    refusalType: {
      type: String,
      default: "",
    },
    // Le refus d'un devis demande la suite à donner (nouveau devis ou modification de la prise en charge) ;
    // le refus d'une facture n'attend qu'un motif.
    showRefusalType: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:reason", "update:refusalType"],
};
</script>

<i18n src="./ApprovalRefusalForm.i18n.json"></i18n>
